import React from 'react'
import UserIcon from "../../../core/gd-components/icons/user/user"
import {ReorderItemProps} from "../../../core/gd-ui/sortable-list-4/@types"
import MyAccountPopover from "../components/my-account-popover"
import Popover from "../../../core/gd-components/gd-popover/popover-v2"
import PopoverPosition from "../../../core/gd-components/gd-popover/popover-position"
import Navigation_BaseButton from "./base-button";
import {UIType} from "../../ui/@const";

type Props = {
    className?          : string,
} & ReorderItemProps

type State = {
    showPopover : boolean
}

export default class Navigation_MyAccountBtn extends React.Component<Props, State>{

    constructor(props: Props) {
        super(props);

        this.state = {
            showPopover : false
        }
    }

    onClick = () => {
        this.setState({
            showPopover : !this.state.showPopover
        })
    };

    onRightClick = (e:React.SyntheticEvent) => {
        // prevent right click
        e.stopPropagation()
        e.preventDefault()
    }

    hidePopover = () => {
        this.setState({showPopover : false})
    }

    render(){

        const classes = Classes('my-account', "m-b-8", this.props.className)

        const position = gd.ui.type === UIType.TOP ? PopoverPosition.bottomRight() : PopoverPosition.leftTop()

        return (
            <Navigation_BaseButton className            = {classes}
                                   showContextMenu      = {this.onRightClick} // prevent right click
                                   isMouseEntered       = {this.props.isMouseEntered}
                                   onClick              = {this.onClick}>

                <UserIcon className="user-icon" userId={gd.user.id} size="26" hint={false} />

                {this.state.showPopover &&
                    <Popover popoverWith      = {275}
                             position         = {position}
                             getTargetFunc    = {() => document.querySelector('.my-account')}
                             onClickOutside   = {this.hidePopover}>
                        <MyAccountPopover hidePopover={this.hidePopover}/>
                    </Popover>}

            </Navigation_BaseButton>
        )
    }
};
